"use client";

import { useSelectContext } from "../__chunks/SLHXTMPQ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/7FZLUSKW.js";
import { useStoreState } from "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-value.tsx
function SelectValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    store = _ref.store,
    fallback = _ref.fallback,
    children = _ref.children;
  var context = useSelectContext();
  store = store || context;
  var value = useStoreState(store, function (state) {
    return (state == null ? void 0 : state.value) || fallback;
  });
  if (children) {
    return children(value || "");
  }
  return value;
}
export { SelectValue };